import {
    IndoorCrashLocationsResult,
    IndoorFlowsResult,
    IndoorLaneUsageResult,
    IndoorLiveResult,
    IndoorSummary,
    IndoorZoneTimeResult,
    KeyedResult
} from '../models/indoor-analytics.model';

export interface IndoorAnalyticsInitialState {
    summary: KeyedResult<IndoorSummary> | null;
    zoneTime: KeyedResult<IndoorZoneTimeResult> | null;
    laneUsage: KeyedResult<IndoorLaneUsageResult> | null;
    flows: KeyedResult<IndoorFlowsResult> | null;
    crashLocations: KeyedResult<IndoorCrashLocationsResult> | null;
    live: KeyedResult<IndoorLiveResult> | null;
}

const initialIndoorAnalyticsState: IndoorAnalyticsInitialState = {
    summary: null,
    zoneTime: null,
    laneUsage: null,
    flows: null,
    crashLocations: null,
    live: null
};

export default initialIndoorAnalyticsState;
